import type { Supplier } from "@albertine/types";
import type { Agent } from "../../common/types/Agent";
import { Flex } from "../Common/Flex";
import FullScreenOverlay from "../Common/Overlay/FullScreenOverlay";
import CatalogItemForm from "./CatalogItemForm";
import WithCatalogItem from "./WithCatalogItem";
import "./EditCatalogItem.css";
import type { CatalogItemFull } from "@albertine/types/openapi";
import { useClaims } from "../../utils/claims.util";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import ItemNotFound from "./ItemNotFound";

type EditCatalogItemProps = {
    catalogItemId: string;
    currentAgent: Agent;
    suppliers: Supplier[];
    onClose: () => void;
    onSave: (savedItem: CatalogItemFull) => void;
};

function EditCatalogItem(props: EditCatalogItemProps) {
    const { catalogItemId, suppliers, onClose, onSave } = props;
    const { isAdmin } = useClaims();

    return (
        <FullScreenOverlay>
            <Flex.Row gap="large" className="edit-catalog-item__title">
                <h2>Edit catalog item</h2>
            </Flex.Row>

            <WithCatalogItem
                catalogId={catalogItemId}
                renderOnError={
                    <ItemNotFound
                        contentItemId={catalogItemId}
                        onClose={() => {
                            onClose();
                        }}
                    />
                }
                renderLoading={
                    <Flex.Column
                        className="edit-catalog-item__loading"
                        alignItems="center"
                        justifyContent="center"
                    >
                        <LoadingSpinner />
                    </Flex.Column>
                }
            >
                {(catalogItem) => (
                    <CatalogItemForm
                        catalogItem={catalogItem}
                        googlePlace={undefined}
                        isAdmin={isAdmin}
                        suppliers={suppliers}
                        onCancel={() => {
                            if (window.confirm("Discard changes?")) {
                                onClose();
                            }
                        }}
                        onSave={(item) => {
                            onSave(item);
                            onClose();
                        }}
                    />
                )}
            </WithCatalogItem>
        </FullScreenOverlay>
    );
}

export default EditCatalogItem;
